import React from "react";
import { useNavigate } from "react-router-dom";
import Alert from "../../../common/layouts/modal/Alert";

interface RegisterAuthorAlertsProps {
    showMidAlert: boolean;
    setShowMidAlert: (value: boolean) => void;
    setShowExtraFields: (value: boolean) => void;
    doSubmit: () => void;

    showStep1BackAlert: boolean;
    setShowStep1BackAlert: (value: boolean) => void;
    setIsSubmitted: (value: boolean) => void;

    showBackAlert: boolean;
    setShowBackAlert: (value: boolean) => void;

    showAlert: boolean;
    setShowAlert: (value: boolean) => void;
    showExtraFields: boolean;
}

/**
 * 작가 등록 폼의 알림/모달 4종을 한 곳에 모아둔 컴포넌트.
 * - 중간 알림(추가 질문 이어서 작성 vs 바로 제출)
 * - 1단계 뒤로가기 알림
 * - 2단계(추가 질문) 뒤로가기 알림
 * - 제출 완료 알림
 */
const RegisterAuthorAlerts: React.FC<RegisterAuthorAlertsProps> = ({
    showMidAlert,
    setShowMidAlert,
    setShowExtraFields,
    doSubmit,
    showStep1BackAlert,
    setShowStep1BackAlert,
    setIsSubmitted,
    showBackAlert,
    setShowBackAlert,
    showAlert,
    setShowAlert,
    showExtraFields,
}) => {
    const navigate = useNavigate();

    return (
        <>
            {showMidAlert && (
                <Alert
                    message={"작성해 주셔서 감사합니다!\n작가님에 대해 조금 더 알려주세요 😊"}
                    confirmText="이어서 작성하기"
                    cancelText="이대로 제출하기"
                    showCancel={true}
                    onCancel={doSubmit}
                    onClose={() => setShowMidAlert(false)}
                    onConfirm={() => {
                        setShowMidAlert(false);
                        setShowExtraFields(true);
                        setTimeout(() => {
                            const extraSection = document.getElementById("extra-fields-section");
                            if (extraSection) {
                                extraSection.scrollIntoView({ behavior: "smooth", block: "start" });
                            }
                        }, 100);
                    }}
                />
            )}

            {showStep1BackAlert && (
                <Alert
                    title=""
                    message={"뒤로 가시면\n추가 정보가 저장되지 않습니다."}
                    confirmText="이동하기"
                    cancelText="계속 작성하기"
                    showCancel={true}
                    onCancel={() => setShowStep1BackAlert(false)}
                    onClose={() => setShowStep1BackAlert(false)}
                    onConfirm={() => {
                        setShowStep1BackAlert(false);
                        setIsSubmitted(true);
                        setTimeout(() => navigate("/author"), 50);
                    }}
                />
            )}

            {showBackAlert && (
                <Alert
                    title=""
                    message={
                        "뒤로 가시면 작성 중인\n추가 정보가 저장되지 않습니다.\n1단계 등록 폼으로 이동하시겠습니까?"
                    }
                    confirmText="이동하기"
                    cancelText="계속 작성하기"
                    showCancel={true}
                    onCancel={() => setShowBackAlert(false)}
                    onClose={() => setShowBackAlert(false)}
                    onConfirm={() => {
                        setShowBackAlert(false);
                        setShowExtraFields(false);
                    }}
                />
            )}

            {showAlert && (
                <Alert
                    title=""
                    message={"작가 신청이 완료되었습니다."}
                    onClose={() => {
                        setShowAlert(false);
                        if (showExtraFields) {
                            window.history.go(-1);
                            setTimeout(() => navigate("/", { replace: true }), 100);
                        } else {
                            navigate("/");
                        }
                    }}
                />
            )}
        </>
    );
};

export default RegisterAuthorAlerts;
